import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { pdfjsWorker } from 'pdfjs-dist/build/pdf.worker.entry';
import BaseModal from 'components/molecules/BaseModal';
import './styles.scss';
import Pagination from '../Pagination';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const PdfModal = () => {
  const { pdfModal, setPdfModal } = useContext(GlobalContext);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <BaseModal isVisible={pdfModal.isVisible} handleClose={() => setPdfModal({ isVisible: false })}>
      <>
        <Document file={pdfModal.url} onLoadSuccess={onDocumentLoadSuccess} className="pdfObject" onContextMenu={(e) => e.preventDefault()}>
          <Page pageNumber={pageNumber} className="pdfObject__page" />
        </Document>
        <Pagination page={pageNumber} setPage={setPageNumber} totalPages={numPages} />
      </>
    </BaseModal>
  );
};

export default PdfModal;
